import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ActivityPage.css";
import OuraNav from "../components/OuraNav";
import CalendarSidebar from "../components/CalendarSidebar";
import fetchBase from "../utils/fetchBase";

export default function ActivityPage() {
    const [logs, setLogs] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {

        const fetchLogs = async () => {
            try {
                const authHeader = "Bearer " + localStorage.getItem("jwt_token");
                const response = await fetch(`${fetchBase}/api/admin/active-or-recent`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authHeader,
                    },
                });

                const data = await response.json();
                setLogs(data);
            } catch (error) {
                console.error("Failed to fetch logs:", error);
            }
        };

        fetchLogs();
        const interval = setInterval(fetchLogs, 5000); // Refresh every 5s
        return () => clearInterval(interval);
    }, [navigate]);



    return (
        <div className="activity-page">
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Employees", href: "/admin/employees" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Activity", href: "/activity" },
                    { label: "Scheduler", href: "/scheduler" },
                    { label: "Payroll", href: "/admin/payroll" }
                ]}
            />

            <div className="glow-center">
                <h1 className="headline">Activity</h1>
                <p className="subheadline">Never miss a moment of employee action</p>
                <div className="glow-ring" />
            </div>

            <div className="main-content">
                <div className="left-sidebar">
                    <div className="sidebar-search">
                        <input type="text" placeholder="Search employees..." />
                    </div>
                    <ul className="activity-sidebar-menu">
                        <li><i className="fas fa-stream"></i> All Activity</li>
                        <li><i className="fas fa-user-check"></i> On Shift</li>
                        <li><i className="fas fa-user-times"></i> Clocked Out</li>
                        <li><i className="fas fa-bell"></i> Notifications</li>
                        <li><i className="fas fa-cog"></i> Settings</li>
                    </ul>
                </div>

                <div className="center-panel">
                    {!Array.isArray(logs) ? (
                        <p>No activity to display.</p>
                    ) : logs.map((log, index) => {

                        const name = log.employee?.firstName && log.employee?.lastName
                            ? `${log.employee.firstName} ${log.employee.lastName.charAt(0)}.`
                            : "Unknown";

                        const clockIn = new Date(log.clockInTime);
                        const clockOut = log.clockOutTime ? new Date(log.clockOutTime) : null;
                        const now = new Date();

                        const isClockedOut = !!clockOut;
                        const timeDiff = isClockedOut ? now - clockOut : now - clockIn;
                        const minutes = Math.floor(timeDiff / 60000);
                        const hours = Math.floor(minutes / 60);

                        const displayTime = isClockedOut
                            ? `Clocked Out: ${clockOut.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                            : `On Shift – ${hours}h ${minutes % 60}m`;

                        const dotColor = isClockedOut ? "orange" : "#00ff88";

                        return (
                            <div key={index} className="employee-card">
                                <div className="status-dot" style={{ backgroundColor: dotColor }} />
                                <h3>{name}</h3>
                                <p>Clocked In: {clockIn.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                                <p>Status: {displayTime}</p>
                            </div>
                        );
                    })}
                </div>

                <div className="right-sidebar">
                    <div className="calendar-wrapper">
                        <CalendarSidebar />
                    </div>
                </div>
            </div>
        </div>
    );
}
